/** Formatting helpers. Every date, figure and identifier renders in IBM Plex Mono. */

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/**
 * The Group reports in Singapore time, and every timestamp the API returns is
 * normalised to UTC. Shifting by +08:00 and then reading the UTC components is
 * what makes an "SGT" label truthful, independent of the visitor's own timezone.
 */
const SGT_OFFSET_MS = 8 * 60 * 60 * 1000;

function toSgt(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return new Date(d.getTime() + SGT_OFFSET_MS);
}

export function formatDate(value) {
  if (!value) return null;
  const d = toSgt(value);
  if (!d) return null;
  return `${String(d.getUTCDate()).padStart(2, '0')} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

export function formatDateTime(value) {
  if (!value) return null;
  const d = toSgt(value);
  if (!d) return null;
  const hh = String(d.getUTCHours()).padStart(2, '0');
  const mm = String(d.getUTCMinutes()).padStart(2, '0');
  return `${formatDate(value)} · ${hh}:${mm} SGT`;
}

export function formatShortDate(value) {
  if (!value) return null;
  const d = toSgt(value);
  if (!d) return null;
  return `${String(d.getUTCDate()).padStart(2, '0')} ${MONTHS[d.getUTCMonth()].slice(0, 3)} ${d.getUTCFullYear()}`;
}

export const CATEGORY_LABELS = {
  financial_results: 'Financial results',
  corporate_action: 'Corporate action',
  agm_egm: 'AGM/EGM',
  general: 'General',
};

export function categoryLabel(key) {
  return CATEGORY_LABELS[key] || 'General';
}
